import { set, subMilliseconds } from 'date-fns';
import { millisecondsInMinute } from 'date-fns/constants';
import { useMemo, useState } from 'react';
import { useInterval } from 'usehooks-ts';
import { ProductType } from './useProducts';

// Allow some flexibility in the funding to account for potential clock
// differences, e.g. if we see an update at 5:59pm, assume it's the 6pm funding.
const FUNDING_TIME_TOLERANCE = 1 * millisecondsInMinute;

export const useFundingIsDue = (products?: ProductType[] | undefined): boolean => {
  const [now, setNow] = useState(new Date());

  useInterval(() => {
    setNow(new Date());
  }, 500);

  const oldestFunding = useMemo(
    () =>
      products?.reduce<number | undefined>(
        (oldest, product) =>
          product.fundingUpdatedAt && (!oldest || product.fundingUpdatedAt < oldest)
            ? product.fundingUpdatedAt
            : oldest,
        undefined
      ),
    [products]
  );

  return useMemo(() => {
    if (!oldestFunding) return false;

    const lastUpdated = new Date(oldestFunding);

    const currentHourWithOffset = subMilliseconds(
      set(now, { minutes: 0, seconds: 0, milliseconds: 0 }),
      FUNDING_TIME_TOLERANCE
    );

    return lastUpdated < currentHourWithOffset;
  }, [now, oldestFunding]);
};
